import React, { memo } from 'react';
import {
  HeaderContainer,
  HeaderContent,
  LogoSection,
  MainLogo,
  NavCenter,
  IdeasLab,
  NavInfo,
  RadicalText,
  NavRight,
  Locations,
  Metadata,
  AnimatedSpan
} from '../styled/Header.styled';
import CorporateToggleComponent from './CorporateToggle';
import { useCorporateMode, usePreloading } from '../../contexts/SiteContext';
import { useConnectionSpeed } from '../../hooks/useConnectionSpeed';
import { getLogoPath } from '../../utils/logoPath';
import TextEffect from '../animations/TextEffect';

const Header = memo(() => {
  const { isCorporateMode } = useCorporateMode();
  const { isPreloading } = usePreloading();
  const { quality } = useConnectionSpeed();

  return (
    <HeaderContainer $isPreloading={isPreloading}>
      <HeaderContent>
        <LogoSection>
          <MainLogo 
            src={getLogoPath('main.svg', quality)} 
            alt="New Work City Logo"
            $isCorporateMode={isCorporateMode}
          />
          <CorporateToggleComponent />
        </LogoSection>
        
        <NavCenter>
          <IdeasLab $isCorporateMode={isCorporateMode}>
            <TextEffect
              effect="typewriter"
              speed={50}
              delay={200}
              as="span"
            >
              IDEAS LAB
            </TextEffect>
          </IdeasLab>
          <NavInfo>
            <RadicalText $isCorporateMode={isCorporateMode}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={1000}
                as="span"
              >
                RADICALLY REIMAGINE ®
              </TextEffect>
            </RadicalText>
          </NavInfo>
        </NavCenter>
        
        <NavRight>
          <Locations $isCorporateMode={isCorporateMode}>
            <AnimatedSpan $isCorporateMode={isCorporateMode}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={2000}
                as="span"
              >
                Hay Street, Perth
              </TextEffect>
            </AnimatedSpan>
            <AnimatedSpan $isCorporateMode={isCorporateMode}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={3000}
                as="span"
              >
                York Street, Sydney
              </TextEffect>
            </AnimatedSpan>
            <AnimatedSpan $isCorporateMode={isCorporateMode}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={4000}
                as="span"
              >
                9TH AVE, NEW YORK
              </TextEffect>
            </AnimatedSpan>
          </Locations>
          <Metadata $isCorporateMode={isCorporateMode}>
            <AnimatedSpan $isCorporateMode={isCorporateMode} $isMetadata={true} $isFirst={true}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={5000}
                as="span"
              >
                EST. 2025
              </TextEffect>
            </AnimatedSpan>
            <AnimatedSpan $isCorporateMode={isCorporateMode} $isMetadata={true} $isFirst={false}>
              <TextEffect
                effect="typewriter"
                speed={50}
                delay={6000}
                as="span"
              >
                12ʰ 16ᵐ 52ˢ–1° 19′ 36″ Virgo
              </TextEffect>
            </AnimatedSpan>
          </Metadata>
        </NavRight>
      </HeaderContent>
    </HeaderContainer>
  );
});

Header.displayName = 'Header';

export default Header;
